<template>
  <section>
    <!-- 用户抬头卡片 -->
    <div class="invoice-title-card" :class="cardType" :type="cardType">
      <van-cell center size="large" class="invoice-title-cell" is-link @click="showList=true">
        <template slot="icon">
          <van-icon v-if="cardType==='add'" class="invoice-title-cell__left-icon" :name="cardLeftIcon" size="40" />
          <van-icon v-else class="invoice-title-cell__left-icon" :name="cardLeftIcon" />
        </template>
        <template slot="default">
          <span v-if="cardType==='add'" class="invoice-title-cell__value">{{cardInfo.addText}}</span>
          <section v-else>
            <div class="invoice-title-cell__text">发票抬头：{{formData.company}}</div>
            <div class="invoice-title-cell__text">电子邮箱：{{formData.email}}</div>
          </section>
        </template>
      </van-cell>
    </div>

    <!-- 用户抬头选项列表 -->
    <van-popup class="invoice-title-option" round v-model="showList" position="bottom">
      <van-radio-group v-model="chosenMarks">
        <van-cell-group>
          <van-cell :class="{'cell-disabled':item.remake1!==titleType}" v-for="(item, index) in titleOption"
            :key="index" :title="item.gmfMc" clickable @click="onChangeOption(item)">
            <van-icon class="invoice-title-option__right-icon" @click="handleEdit(item.remake1!==titleType)"
              slot="right-icon" name="edit" />
            <van-radio slot="icon" :disabled="item.remake1!==titleType" :name="item.id" />
          </van-cell>
        </van-cell-group>
      </van-radio-group>
      <div class="btn_box bottom">
        <van-button @click="createInvoiceTitle" size="large" class="blue-btn">
          新建发票抬头
        </van-button>
      </div>
    </van-popup>

    <!-- 用户抬头新增/修改 -->
    <van-popup class="invoice-title-edit" round v-model="showEdit" position="bottom">
      <van-form validate-first @submit="onSaveAndSubmit" class="invoice-title-edit__form">
        <van-field name="titleType" label="抬头类型">
          <template #input>
            <van-radio-group v-model="formData.titleType" direction="horizontal">
              <van-radio icon-size="14px" name="1" :disabled="formData.titleType==='2'">
                公司抬头
              </van-radio>
              <van-radio icon-size="14px" name="2" :disabled="formData.titleType==='1'">
                个人/非企业抬头
              </van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <smartinput :company='formData.company' v-bind="provinceList" v-if="isCompany.status" @collect="collectProvince"
          @searchtxt="getinvoice">
        </smartinput>
        <van-field required v-model="formData.company" v-else name="company" :label="isCompany.label"
          :rules="[{ required: true, message: '请输入发票抬头' }]" :placeholder="isCompany.placeholder" />
        <van-field required v-model="formData.gmf_nsrsbh" name="gmf_nsrsbh" v-if="isCompany.status" label="发票税号"
          :rules="taxRules" placeholder="请输入发票税号" />
        <van-field required v-model="formData.email" name="email" label="电子邮箱" :rules="emailRules"
          placeholder="请输入电子邮箱" />
        <van-field required v-model="formData.phone" name="phone" label="手机号码" :rules="phoneRules"
          placeholder="请输入手机号码" />
        <!-- <van-cell center title="设为默认">
          <van-switch v-model="isDefault" slot="right-icon" size="24" />
        </van-cell> -->
        <div class="btn_box bottom">
          <van-button native-type="submit" size="large" class="blue-btn">
            保存并使用
          </van-button>
        </div>
      </van-form>
    </van-popup>
  </section>
</template>

<script>
import { Form, Field, CellGroup, RadioGroup, Radio, Dialog, Popup, Icon, Switch } from 'vant'
import config from '@/config/index'
import smartinput from '@/components/SmartInput/index'
import { getInvoiceTitleInfoByBW, addBillingInformation, getInvoiceTitleInfo, ChangeInvoiceInfomation } from '@/api/invoice'
export default {
  props: {
    titleType: {//抬头类型
      type: String,
      default: '1'
    },
    titleList: {//抬头列表
      type: Array,
      required: true
    },
    parkId: {//抬头列表
      type: Number,
      required: true
    },
  },
  components: {
    smartinput,
    [Form.name]: Form,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Dialog.Component.name]: Dialog.Component,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [Switch.name]: Switch
  },
  computed: {
    cardType () {
      if (this.chosenMarks !== null) {
        return 'edit'
      } else {
        return 'add'
      }
    },
    cardLeftIcon () {
      if (this.chosenMarks !== null) {
        return 'contact'
      } else {
        return 'add-square'
      }
    },
    isCompany () {
      let obj = {};
      if (this.formData.titleType == '1') {//公司
        obj.status = true;
        obj.label = "公司抬头";
        obj.placeholder = "请输入公司抬头名称";
        return obj
      } else {//个人
        obj.status = false;
        obj.label = "抬头名称";
        obj.placeholder = "请输入个人姓名/店名";
        return obj
      }
    }
  },
  watch: {
    titleList: {
      handler (newVal, oldVal) {
        if (newVal == oldVal) {
          return
        }
        this.titleOption = newVal
      },
      deep: true
    },
    titleType: {
      handler (newVal, oldVal) {
        if (newVal == oldVal) {
          return
        }
        this.formData.titleType = newVal
        this.chosenMarks = null
        for (let item of this.titleOption) {
          if (item.remake1 == newVal) {
            this.chosenMarks = item.id
            this.onChangeOption(item)
            return
          }
        }
        if (this.chosenMarks == null) {
          let row = { remake1: newVal, content: 1 }
          this.onChangeOption(row)
        }


      },
      deep: true
    }
  },
  data () {
    this.phoneRules = [
      { required: true, message: '请输入手机号码' },
      { validator: this.phoneValidator, message: '手机号码格式错误' },
    ];
    this.emailRules = [
      { required: true, message: '请输入邮箱' },
      { validator: this.emailValidator, message: '邮箱格式错误' },
    ];
    this.taxRules = [
      { required: true, message: '请输入税号' },
      { validator: this.taxValidator, message: '纳税人识别号格式错误' },
    ];
    return {
      provinceList: {
        list: []
      },
      config,
      pttitleList: [],//票通模糊列表
      handleType: "add",//弹窗处理类型
      showList: false, //选项列表
      showEdit: false, //抬头信息
      isDefault: true,//是否默认抬头信息
      chosenMarks: null,//选择项标识（id）
      cardInfo: {
        addText: "选择抬头信息",
      },
      titleOption: [],//抬头列表
      formData: {
        titleType: "1",//抬头类型（非参数）
        company: "", //发票抬头
        gmf_nsrsbh: "",//购买方发票税号
        email: "",//邮箱
        phone: ""//手机号码
      }
    }
  },
  methods: {
    // 获取票通抬头
    getinvoice (item) {
      if (this.config.projectName == 'NJNZ') {
        let params = {
          parkId: this.parkId,
          companyName: item
        }
        getInvoiceTitleInfoByBW(params).then(res => {
          this.pttitleList = res.body || []
          this.provinceList.list = []
          this.pttitleList.forEach(item => {
            this.provinceList.list.push(item.enterpriseName)
          })
        }).catch(err => {
          this.$notify({
            type: 'danger',
            message: err
          })
        })
      } else if (this.config.projectName == 'CTC') {
        let params = {
          parkId: this.parkId,
          enterpriseName: item
        }
        getInvoiceTitleInfo(params).then(res => {
          this.pttitleList = res.body || []
          this.provinceList.list = []
          this.pttitleList.forEach(item => {
            this.provinceList.list.push(item.enterpriseName)
          })
        }).catch(err => {
          this.$notify({
            type: 'danger',
            message: err
          })
        })      }
    },
    // 跟智能输入框同步选中的业务
    collectProvince (data) {
      this.formData.company = data
      this.pttitleList.forEach(item => {
        if (item.enterpriseName == data) {
          this.formData.gmf_nsrsbh = item.taxpayerNum
        }
      })
    },
    // 选项切换
    onChangeOption (row) {
      if (row.remake1 !== this.titleType) {//不同抬头类型不可点击
        return
      }
      if (row.content == 1) {//如果该类型没有就清空
        this.formData.company = '' //发票抬头
        this.formData.gmf_nsrsbh = '' //购买方发票税号
        this.formData.email = '' //电子邮箱
        this.formData.phone = '' //手机号码     
        this.formData.titleType = '' //抬头类型（非参数）
        this.formData.titleType = row.remake1 //抬头类型（非参数）
        this.$store.dispatch('invoice/SetUserInvoiceTitle', this.formData)//提交给父组件
        this.showList = false //关闭弹窗
        return
      }
      // this.titleType = row.remake1
      this.chosenMarks = this.formData.id = row.id //选择项标识（id）
      this.formData.company = row.gmfMc //发票抬头
      this.formData.gmf_nsrsbh = row.gmfNsrsbh //购买方发票税号
      this.formData.email = row.jffEmail //电子邮箱
      this.formData.phone = row.jffPhone //手机号码     
      this.formData.titleType = row.remake1 //抬头类型（非参数）
      this.$store.dispatch('invoice/SetUserInvoiceTitle', this.formData)//提交给父组件
      this.showList = false //关闭弹窗
    },
    // 编辑抬头
    handleEdit (item) {
      if (item == true) {
        return
      }
      this.handleType = "edit"
      this.showEdit = true
    },
    // 新建发票抬头
    createInvoiceTitle () {
      this.resetTemp()
      this.handleType = "add"
      this.showEdit = true; //打开编辑窗口
    },
    // 保存并使用
    onSaveAndSubmit () {
      this.showList = false //关闭弹窗
      this.showEdit = false; //打开编辑窗口
      this.$store.dispatch('invoice/SetUserInvoiceTitle', this.formData)
      // if (this.titleOption.map(item => item.id).indexOf(this.formData.id) < 0) {
      //   this.titleOption.push(this.formData)//查询并设置
      //   this.onChangeOption(this.formData)
      // }
      let params = { //参数
        gmfNsrsbh: this.formData.gmf_nsrsbh,
        gmfMc: this.formData.company,
        gmfDzdh: '',
        jffPhone: this.formData.phone,
        gmfYhzh: '',
        jffEmail: this.formData.email,
        remake1: this.titleType
      }
      let meth //判定方法为新增还是修改
      if (this.handleType == "add") {
        meth = addBillingInformation
      } else {
        meth = ChangeInvoiceInfomation,
          params.id = this.formData.id
      }

      meth(params).then(res => {
        console.log(res)
        this.chosenMarks = -1
        this.$notify({
          type: res.status == 1001 ? 'success' : 'danger',
          message: res.message
        })
        this.$parent.getInoiceList();
      }).catch(err => {
        this.$notify({
          type: 'danger',
          message: err
        })
      })

    },
    resetTemp () {
      this.formData = {
        id: this.titleOption.length,
        titleType: this.titleType,
        company: "", //发票抬头
        gmf_nsrsbh: "",//购买方发票税号
        email: "",//邮箱
        phone: ""//手机号码
      }
    },
    // 校验函数返回 true 表示校验通过，false 表示不通过
    emailValidator (val) {
      return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(val);
    },
    phoneValidator (val) {
      return /^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(val);
    },
    taxValidator (val) {
      return /^[A-Z0-9]{15}$|^[A-Z0-9]{17}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/.test(val);
    }
  },
  mounted () {
    // // 获取默认抬头
    // let info = getLocalStorage('titleinfo')
    // if (info) {
    //   this.chosenMarks = info.id
    //   this.titleType = info.type
    //   this.titleOption = [info.data]
    // }
  }
}
</script>

<style lang="scss" scoped>
.invoice-title-cell {
  /deep/ .van-cell__value {
    margin-left: 5px;
  }
  &__value {
    font-size: 14px;
  }
  &__text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &__left-icon {
    color: $blue;
    font-size: 22px;
    margin-right: 5px;
  }
}
.invoice-title-option {
  /deep/ .van-radio__icon {
    margin-right: 5px;
  }
  &__right-icon {
    font-size: 24px;
  }
}
.invoice-title-cell::before {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 2px;
  background: -webkit-repeating-linear-gradient(
    135deg,
    #ff6c6c 0,
    #ff6c6c 20%,
    transparent 0,
    transparent 25%,
    #1989fa 0,
    #1989fa 45%,
    transparent 0,
    transparent 50%
  );
  background: repeating-linear-gradient(
    -45deg,
    #ff6c6c 0,
    #ff6c6c 20%,
    transparent 0,
    transparent 25%,
    #1989fa 0,
    #1989fa 45%,
    transparent 0,
    transparent 50%
  );
  background-size: 80px;
  content: "";
}
.btn_box {
  width: calc(100vw - 30px);
  max-width: 600px;
}
.bottom {
  margin: 20px auto 20px;
}
</style>